/**
 * TEMPLATES
 * 
 * module de gestion des templates
 */
const utils = require('./utils.js').default;
import $ from "jquery";
import { tpl } from '../../../helpers/tpl.js';
import { dialog } from '../../../components/dialog.js';
import { gtm } from '../../../components/gtm.js';

const templates = (() => {
    /**
     * TEMPLATE COMMON PART
     */
    const templateCommonPart = () => {
        document.addEventListener('TEMPLATE_COMMON_PART', (event) => {
            utils.debug('TEMPLATE COMMON PART', event.detail);
            let templateId = event.detail.templateId;
            let targetElement = event.detail.targetElement;
            let data = event.detail.data;
            if (event.detail.append !== undefined && event.detail.append) {
                $(targetElement).append(tpl.get(data, templateId));
            } else {
                $(targetElement).html(tpl.get(data, templateId));
            }
        });
    };
    /**
     * TEMPLATE ADDRESS
     */
    const templateAddress = () => {
        document.addEventListener('TEMPLATE_ADDRESS', (event) => {
            // utils.debug('TEMPLATE ADDRESS', event.detail);
            let templateID = 'tpl-address';
            let target = event.detail.target;
            let data = event.detail.address;
            if (!data.show_delete) {
                data.delete_class = 'remove';
            } else {
                data.delete_class = '';
            }
            $(target).append(tpl.get(data, templateID));
            $(target).find('.tools .delete.remove').remove();
        });
    };
    /**
     * TEMPLATE ADDRESS EMPTY
     */
    const templateAddressEmpty = () => {
        document.addEventListener('TEMPLATE_ADDRESS_EMPTY', (event) => {
            // utils.debug('TEMPLATE ADDRESS EMPTY', event.detail);
            let templateID = 'tpl-address-empty';
            let target = event.detail.target;
            let data = {};
            $(target).html(tpl.get(data, templateID));
        });
    };
    /**
     * TEMPLATE DOC
     */
    const templateDoc = () => {
        document.addEventListener('TEMPLATE_DOC', (event) => {
            // utils.debug('TEMPLATE DOC', event.detail);
            let templateID = 'tpl-doc';
            let target = event.detail.target;
            let data = event.detail.data;
            $(target).append(tpl.get(data, templateID));
        });
    };
    /**
     * TEMPLATE DOCS EMPTY
     */
    const templateDocsEmpty = () => {
        document.addEventListener('TEMPLATE_DOCS_EMPTY', (event) => {
            // utils.debug('TEMPLATE DOC EMPTY', event.detail);
            let templateID = 'tpl-docs-empty';
            let target = event.detail.target;
            let data = {};
            $(target).html(tpl.get(data, templateID));
        });
    };
    /**
     * TEMPLATE DOCS GROUP
     */
    const templateDocsGroup = () => {
        document.addEventListener('TEMPLATE_DOCS_GROUP', (event) => {
            // utils.debug('TEMPLATE DOCS GROUP', event.detail);
            let templateID = 'tpl-docs-group';
            let target = event.detail.target;
            if(event.detail.url) {
            }
            const name = (event.detail.url) ? `<a href="${event.detail.url}">${event.detail.name}</a>` : event.detail.name;
            let data = {
                name,
                id: event.detail.id,
            };
            $(target).append(tpl.get(data, templateID));
        });
    };
    /**
     * TEMPLATE ERROR
     */
    const templateError = () => {
        document.addEventListener('TEMPLATE_ERROR', (event) => {
            // utils.debug('TEMPLATE ERROR', event.detail);
            let popinTargetID = 'popin-error';
            let data = {
                error: event.detail.error,
            };
            utils.debug('WL ERROR', data.error);   
            $(`[data-js-dialog-id="${popinTargetID}"]`)
                .html(tpl.get(data, popinTargetID));
            utils.dispatchCustomEvent('LOADER', {show:false});
            dialog.close();
            dialog.open(popinTargetID);
                // .find('.popin-open').trigger('click');
        });
    };
    /**
     * TEMPLATE POPIN COMMON
     */
    const templatePopinCommon = () => {
        document.addEventListener('TEMPLATE_POPIN_UPDATE', (event) => {
            // utils.debug('TEMPLATE POPIN COMMON', event.detail);
            let popinTargetID = event.detail.popinTargetID;
            let data = event.detail.data;
            $(`[data-js-dialog-id="${popinTargetID}"]`)
                .html(tpl.get(data, popinTargetID));
        });
    };
    /**
     * TEMPLATE WISHLIST EMPTY
     */
    const templateWishlistEmpty = () => {
        document.addEventListener('TEMPLATE_WISHLIST_EMPTY', (event) => {
            // utils.debug('TEMPLATE WISHLIST EMPTY', event.detail);
            let templateID = 'tpl-wishlist-empty';
            let target = event.detail.target;
            let data = {};
            $(target).html(tpl.get(data, templateID));
            $('body').removeClass('wishlist-not-empty');
        });
    };
    /**
     * TEMPLATE WISHLISTLIST DETAILS
     */
    const templateWishlistListDetails = () => {
        document.addEventListener('TEMPLATE_WISHLIST_LIST_DETAILS', (event) => {
            // utils.debug('TEMPLATE WISHLIST DETAILS', event.detail);
            let templateID = 'tpl-wishlist-list-details';
            let target = event.detail.target;
            let data = {};
            $(target).html(tpl.get(data, templateID));
            utils.dispatchCustomEvent('TEMPLATE_WISHLIST_LIST_DETAILS_LOADED');
        });
    };
    /**
     * TEMPLATE WISHLIST LIST DETAILS PRODUCTS
     */
    const templateWishlistListDetailsProducts = () => {
        document.addEventListener('TEMPLATE_WISHLIST_LIST_DETAILS_PRODUCTS', (event) => {
            // utils.debug('TEMPLATE WISHLIST LIST DETAILS PRODUCTS', event.detail);
            let templateID = 'tpl-wishlist-list-details-products';
            let templateCategoryID = 'tpl-wishlist-list-details-category';
            let target = event.detail.target;
            let data = event.detail.data;
            const price = parseInt(data.totalPrice.replace('€', ''));
            if (utils.getContext() === 'pro' && price === 0) {
                const brandLower = (data.brand || '').toLowerCase();
                if (['legrand energies solutions'].includes(brandLower)) {
                    data.totalPrice = '<a href="/pro/nous-contacter/contact-responsable-commercial-legrand-energies-solutions">Contactez un commercial</a>';
                } else {
                    data.totalPrice = '<a href="/pro/nous-contacter/contact-responsable-commercial-en-local">Contactez un commercial</a>';
                }
                data.totalPriceClass = "price-disable";
            } else {
                data.totalPriceClass = "price-enable";
            }
            // si pas de catégory, on l'ajoute
            if ($(target).children(`#${data.categoryID}`).length === 0){
                $(target).append(tpl.get(data, templateCategoryID));
            }
            $(target).append(tpl.get(data, templateID));
            $('body').addClass('wishlist-not-empty');
        });
    };
    /**
     * TEMPLATE WISHLIST LIST TITLE
     */
    const templateWishlistListTitle = () => {
        document.addEventListener('TEMPLATE_WISHLIST_LIST_TITLE', (event) => {
            // utils.debug('TEMPLATE WISHLIST LIST TITLE', event.detail);
            let templateID = 'tpl-wishlist-list-title';
            let target = event.detail.target;
            let data = {
                name: event.detail.name,
                count: event.detail.count.toString(),
            };
            $(target).html(tpl.get(data, templateID));
        });
    };
    /**
     * TEMPLATE WISHLISTS ALL
     */
    const templateWishlistsAll = () => {
        document.addEventListener('TEMPLATE_WISHLIST_ALL_LISTS', (event) => {
            // utils.debug('TEMPLATE WISHLIST ALL', event.detail);
            let templateID = 'tpl-wishlist-all-lists';
            let target = event.detail.target;
            let data = {};
            $(target).html(tpl.get(data, templateID));
        });
    };
    /**
     * TEMPLATE WISHLISTS LIST
     */
    const templateWishlistslist = () => {
        document.addEventListener('TEMPLATE_WISHLIST_ALL_LIST', (event) => {
            // utils.debug('TEMPLATE WISHLIST LIST', event.detail);
            let templateID = 'tpl-wishlist-all-list';
            let target = event.detail.target;
            let data = event.detail.data;
            
            $(target).append(tpl.get(data, templateID));
            if (data.id === 'liste-de-materiel') {
                $(target).find('tr[data-id="liste-de-materiel"] .rename').remove();
                $(target).find('tr[data-id="liste-de-materiel"] .delete').remove();
            }
        });
    };
    /**
     * INIT (func)
     */
    const init = () => {
        templateCommonPart();
        templateAddress();
        templateAddressEmpty();
        templateDoc();
        templateDocsEmpty();
        templateDocsGroup();
        templateError();
        templatePopinCommon();
        templateWishlistEmpty();
        templateWishlistListDetails();
        templateWishlistListDetailsProducts();
        templateWishlistListTitle();
        templateWishlistsAll();
        templateWishlistslist();
    };
    return {init};
})();
export default templates;